import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';


import {
  IApplication,
  IApplicationInput,
  IApprovalTask,
  IHelp,
  HelpApiService
} from '@ebb-v2/ebb-integration';
import { Console } from 'console';
import { cloneDeep } from 'lodash';
import { DialogConfirmMessageComponent } from '../dialog/dialog-confirm-message.component';

@Component({
  selector: 'ebb-portal-permitreceipt-sg-form',
  templateUrl: './permitreceipt-sg-form.component.html'
})
export class PermitReceiptSgFormComponent implements OnInit {
  @Input() set application(value: IApplication) {
    this.applicationData = value;
    this.permitHomeownerPaid = value.sGHomeownerPaidPermit;
    
    if (value && this.formPermitReceiptInfo) {

      //If homeowner has not yet explicitly chosen yes or no, set to null.
      //Else, use homeowner choice.
      this.formPermitReceiptInfo.controls['permitHomeownerPaid'].setValue(
        value.sGPermitReceiptSubmittedHomeowner !== true
        ?
        null
        :
        value.sGHomeownerPaidPermit === true
        ?
        'yes'
        :
        'no'
      );
      

      this.formPermitReceiptPriorValue = this.formPermitReceiptInfo.controls['permitHomeownerPaid'].value;
      this.emitPermitReceiptChoiceEvent.emit(this.formPermitReceiptPriorValue === null ? false : true);

      //prevent user from losing their cost update if update file
      const currentCostValue = this.formPermitReceiptInfo.controls['permitCost'].value;
      
      if (this.permitHomeownerPaid && !currentCostValue) {
        this.formPermitReceiptInfo.controls['permitCost'].setValue(value.permitCost);
      }

      //disable if invoice is submitted for payment
      if (this.applicationData.sGPermitReceiptSubmitted === 1) {
        this.sgPermitReceiptSubmitted = true;
        this.formPermitReceiptInfo.disable();
      //disable if submitted for preliminary review (not rejected)
      } else if (this.applicationData.stageCode === 700000000 &&
        (this.applicationData.eventPreliminaryReview !== true ||
        this.applicationData.applicationStatusOptionSet === 'Preliminary Review Rejected')) {
        this.sgPermitReceiptSubmitted = false;
        this.formPermitReceiptInfo.enable();
      } else {
        this.sgPermitReceiptSubmitted = false;
        this.formPermitReceiptInfo.disable();
      }
    }
  }
  @Input() set taskSG(value: IApprovalTask) {
    this.taskSgFiltered = cloneDeep(value) as IApprovalTask;
    this.loading = false;
    this.taskSgFiltered.approvalTaskItems =
      this.taskSgFiltered.approvalTaskItems.filter(x => x.payloadTypeCode === 700000000 && x.name === this.taskitemname ); //payload type of file
    if (this.formPermitReceiptInfo) {
      const taskItem = 
        this.taskSgFiltered.approvalTaskItems.length > 0 
        ? this.taskSgFiltered.approvalTaskItems[0] 
        : undefined;
      this.formPermitReceiptInfo.controls['permitReceiptFileAttached'].setValue(
        taskItem && 
        taskItem.payload && 
        (taskItem.statusCode === 700000000 || taskItem.statusCode === 700000003)
      );
    }
  }
  @Input('w9Shown') w9Shown: boolean;
  @Output() emitContractorUpdateEvent = new EventEmitter<IApplicationInput>();
  @Output() emitFileUploadEvent = new EventEmitter<IApprovalTask>();
  @Output() emitPermitReceiptApplicationChangeEvent = new EventEmitter<IApplicationInput>();
  @Output() emitPermitReceiptChoiceEvent = new EventEmitter<boolean>();

  public listHelp: IHelp[] = [];
  public textPermitReceiptFileIntroSgHelpText = '';
  public textPermitReceiptCostIntroSgHelpText = '';
  public taskSgFiltered: IApprovalTask;
  public applicationData: IApplication;
  public sgPermitReceiptSubmitted = true;
  public loading = false;
  public formPermitReceiptInfo: FormGroup;
  public permitHomeownerPaid: boolean;
  public formPermitReceiptPriorValue: string;
  public isSgQualify = false;
public taskitemname = "Permit Receipt";
  constructor(
    private readonly apiHelp: HelpApiService,
    private readonly dialogConfirmSubmit: MatDialog,
    private _fb: FormBuilder,
  ) {
    this.permitHomeownerPaid = false;
    this.formPermitReceiptInfo = this._fb.group({
      permitCost: [null,
        [
          Validators.required,
          Validators.min(1)
         
        ]
      ],
      permitHomeownerPaid: [null,
        [
          Validators.required
        ]
      ],
      permitReceiptFileAttached: [null,
        [
          Validators.requiredTrue
        ]
      ]
    });
  }

  ngOnInit() {

    this.loadHelpText();
  }

  private loadHelpText(): void {
    this.apiHelp.setCurrentHelpTopicValue('Sgpermitreceipt');
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = JSON.parse(JSON.stringify(data));
          const indexPermitReceiptFileIntroSgHelpText = this.listHelp.findIndex(i => i.name.toLowerCase() === 'sgpermitreceiptfileintro');
          this.textPermitReceiptFileIntroSgHelpText = this.listHelp[indexPermitReceiptFileIntroSgHelpText] ? this.listHelp[indexPermitReceiptFileIntroSgHelpText].answer : 'content missing: sgpermitreceiptfileintro';

          const textPermitReceiptCostIntroSgHelpText = this.listHelp.findIndex(i => i.name.toLowerCase() === 'sgpermitreceiptcostintro');
          this.textPermitReceiptCostIntroSgHelpText = this.listHelp[textPermitReceiptCostIntroSgHelpText] ? this.listHelp[textPermitReceiptCostIntroSgHelpText].answer : 'content missing: sgpermitreceiptcostintro';
        },
        error => console.log(error)
      );
  }

  onChangeEventPermitReceipt($event: MatRadioChange ) {
    this.emitPermitReceiptChoiceEvent.emit(true);
    if ($event.value === 'no' && this.applicationData.sGPermitReceiptSubmittedHomeowner === true) {
      const dialogViewDataItem = {
        title: 'Permit Receipt',
        message: 'Are you sure you want to cancel? All information for your permit receipt will be lost.',
        buttonCancelLabel:'No',
        buttonlabel:'Yes' };
      const dialogRefConfirm = this.dialogConfirmSubmit.open(
        DialogConfirmMessageComponent,
        { width: '400px', data: dialogViewDataItem }
      );
      dialogRefConfirm.afterClosed().subscribe(result => {
        if (result === 1) {
          this.formPermitReceiptInfo.controls['permitHomeownerPaid'].disable();
          this.permitHomeownerPaid = false;
          const applicationUpdate: IApplicationInput = {} as IApplicationInput;
          applicationUpdate.sGHomeownerPaidPermit = false;
          applicationUpdate.sGPermitReceiptSubmittedHomeowner = true;
          this.emitPermitReceiptApplicationChangeEvent.emit(applicationUpdate);
          this.loading = true;
        } else {
          this.formPermitReceiptInfo.controls['permitHomeownerPaid'].setValue('yes');
        }
      });
    } else if ($event.value === 'yes') {
        this.permitHomeownerPaid = $event.value === 'yes';
        this.formPermitReceiptInfo.controls['permitHomeownerPaid'].disable();
        const applicationUpdate: IApplicationInput = {} as IApplicationInput;
        applicationUpdate.sGHomeownerPaidPermit = (this.formPermitReceiptInfo.controls['permitHomeownerPaid'].value === 'yes' ? true : false);
        applicationUpdate.sGPermitReceiptSubmittedHomeowner = true;
        applicationUpdate.permitCost = this.formPermitReceiptInfo.controls['permitCost'].value;
        this.emitPermitReceiptApplicationChangeEvent.emit(applicationUpdate);
        this.loading = true;
    } else {
      const applicationUpdate: IApplicationInput = {} as IApplicationInput;
      applicationUpdate.sGPermitReceiptSubmittedHomeowner = true;
      this.emitPermitReceiptApplicationChangeEvent.emit(applicationUpdate);
  }

    this.formPermitReceiptPriorValue = $event.value;
  }

  onClickSavePermitReceiptInfo() {
    if(this.formPermitReceiptInfo.valid) {
      
      //alert popup only if W-9 is not complete
      if(this.w9Shown && !this.applicationData.w9DataSubmitted) {
        const dialogViewDataItem = {
          title: 'W-9 Form',
          message: 'To be paid for your permit receipt as soon as possible, please complete the W-9 section.',
          buttonlabel:'OK' };
        const dialogRefConfirm = this.dialogConfirmSubmit.open(
          DialogConfirmMessageComponent,
          { width: '400px', data: dialogViewDataItem }
        );
      }

      const applicationUpdate: IApplicationInput = {} as IApplicationInput;
      applicationUpdate.sGHomeownerPaidPermit = (this.formPermitReceiptInfo.controls['permitHomeownerPaid'].value === 'yes' ? true : false);
      applicationUpdate.sGPermitReceiptSubmitted = 1;
      applicationUpdate.permitCost = Number(this.formPermitReceiptInfo.controls['permitCost'].value);
      this.sgPermitReceiptSubmitted = true;
      this.formPermitReceiptInfo.disable();
      this.emitPermitReceiptApplicationChangeEvent.emit(applicationUpdate);
    }
  }
  public setCostToZeroIfEmpty(event) {
    if (
      event.target.value === '' ||
      event.target.value <= 0 ||
      event.target.value < 0.01
    ) {
      event.target.value = 0;
    }
  }

  onEmitFileUploadEvent($event: IApprovalTask) {
    this.emitFileUploadEvent.emit($event);
  }

  checkPermitReceiptFormLock() : boolean{
    return !this.formPermitReceiptInfo.valid;
  }

}


